<template>

    <accordion :collections="groupTerms" :initialExpanded="expandedGroupTerm" @expanded="showGroupTerm">
        <template scope="groupTerm">

            <timeline :items="timelineItems" :isActive="isPeriodActive" :isMarked="isPeriodCurrent">

                <template slot="item" scope="data">
                    <period :groupPeriod="data.groupPeriod" :start="data.start" :end="data.end" :isDemo="isDemo"></period>
                </template>

            </timeline>

        </template>
    </accordion>

</template>


<script>

import Accordion from 'js/admin/components/sidebar/Accordion.vue'
import Timeline from 'js/admin/components/sidebar/Timeline.vue'
import Period from 'js/components/sidebar/Period.vue'

import notify from 'js/components/notifications/notificationsMixin'

import { getGroupTermsForGroup, getProgressForUserAndGroupTerm } from 'js/vuex/getters'

import moment from 'js/helpers/moment'

export default {
    mixins: [ notify ],

    components: { Accordion, Timeline, Period },

    props: {
        group: {},
        groupTerm: {},
        isDemo: {
            type: Boolean,
            default: false,
        }
    },

    vuex: {
        getters: {
            getGroupTermsForGroup,
            getProgressForUserAndGroupTerm
        },
    },

    computed: {

        expandedGroupTerm: function() {
            return this.$route.name === 'group.overview' ? null : this.groupTerm.id
        },

        timelineItems: function() {

            return this.groupPeriods.map( (gp, index) => {
                return {
                    id: gp.id,
                    groupPeriod: gp,
                    start: this.periodStart(index),
                    end: this.periodEnd(index),
                }
            })

        },

        groupPeriods: function() {
            if ( this.groupTerm == null ) {
                return []
            }

            return this.groupTerm.groupPeriods.map( id => this.$store.state.groups.periods[id] )
        },

        groupTerms: function() {
            const overview = {
                id: -1,
                title: 'Overzicht',
                isFirst: false,
                isExpandable: false,
                link: { name: 'group.overview' }
            }

            const terms = this.getGroupTermsForGroup(this.group.id)
                .filter(gt => gt.term != null && gt.term.length > 0)
                .map( (gt, index) => {
                    const term = this.$store.state.terms.storage[ gt.term[0] ]
                    return {
                        id: gt.id,
                        title: (index+1) + '. ' + term.title,
                        isFirst: index === 0,
                    }
                })

            return [overview].concat(terms)
        },

        currentGroupTermId: function() {
            return this.group.currentGroupTerm[0]
        },

        currentGroupPeriodId: function() {
            const gt = this.$store.state.groups.terms[ this.currentGroupTermId ]
            return gt.currentGroupPeriod == null ? null : gt.currentGroupPeriod[0]
        },

    },

    methods: {

        viewPeriod: function(data) {
            this.$router.push({ name: 'group.period', params: { periodId: data.groupPeriod.id } })
        },

        isPeriodActive: function(groupPeriod) {
            return this.$route.params.periodId === groupPeriod.id && this.$route.name === 'group.period'
        },

        isPeriodCurrent: function(groupPeriod) {
            return this.currentGroupPeriodId === groupPeriod.id
        },

        showGroupTerm: function(groupTerm) {
            this.$router.push({ name: 'students.overview', params: { groupTermId: groupTerm.id }})
        },

        periodStart: function(index) {
            if ( index === 0 ) {
                return moment( this.groupTerm.start * 1000 )
            }

            return moment( this.groupPeriods[index - 1].end * 1000 ).add(1, 'days')
        },

        periodEnd: function(index) {
            return moment( this.groupPeriods[index].end * 1000 )
        },


    },


}
</script>



<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// SidebarContentTerms.vue?3c815e06